import React from 'react';
import Paper from '@mui/material/Paper';
import './AuthCard.css';

function AuthCard({ children, sx, ...props }) {
    return (
        <Paper
            className="auth-card"
            sx={{
                maxWidth: 380,
                mx: 'auto',
                mt: { xs: 2, sm: 6 },
                p: { xs: 3, sm: 4 },
                bgcolor: '#0a0a0b',
                color: '#ffffff',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                ...sx,
            }}
            {...props}
        >
            {children}
        </Paper>
    );
}

export default AuthCard;
